import { type PointerEventHandler } from 'react'
import { type BranchOption, type ResolvedBranchNode } from '@/lib/branchTypes'
import { splitPlanLabel } from '../splitPlanLabel'

type PrimaryButton2ChoicesTwoProps = {
  option: BranchOption
  targetNode: ResolvedBranchNode | null
  inverted: boolean
  showHoverStyleByDefault: boolean
  onClick: () => void
  onPointerEnter: PointerEventHandler<HTMLElement>
  onPointerLeave: PointerEventHandler<HTMLElement>
}

// "Our Recommendation" CTA for binary forks; lives apart from the 5-up version so two-choice tweaks stay local.
export const PrimaryButton2ChoicesTwo = ({
  option,
  targetNode,
  inverted,
  showHoverStyleByDefault,
  onClick,
  onPointerEnter,
  onPointerLeave,
}: PrimaryButton2ChoicesTwoProps) => {
  return (
    <div className="flex-1">
      <button
        onClick={onClick}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
        className={`w-1/2 rounded-md font-bold tracking-wide transition-colors cursor-pointer border flex flex-col flex-1 items-center w-full justify-center border-current pt-7 pb-7 px-3 sm:px-6 md:px-10 -mt-2 border-4 text-2xl ${inverted ? 'bg-black text-white' : showHoverStyleByDefault ? 'bg-black/5 hover:bg-black/5' : 'bg-transparent hover:bg-black/5'}`}
      >
        {option.label}
        {targetNode?.subtitle && <div className={`hidden md:block font-mono font-normal mt-1 text-sm uppercase ${inverted ? 'text-gray-400' : 'text-gray-500'}`}>{targetNode.subtitle}</div>}
      </button>
      <div className="font-mono text-center font-normal mt-3 text-[9px] text-gray-500 text-nowrap">(Our Recommendation)</div>
    </div>
  )
}
